import { ReactElement } from 'react';
import { useExperiment } from '@twiliointernal/e2-commons-shared-hooks';

import { WiseOwlViewV1, WiseOwlViewV2 } from './sub';
import { constants } from './definitions';
import { useGetExperimentAccountSid } from '../../providers/experimentProvider';
import PageLoader from '../pageLoader';

const WiseOwlView = (): ReactElement => {
  const experimentAccountSid = useGetExperimentAccountSid();
  const { isOn: isWiseOwlV2Enabled, isLoadingTreatment } = useExperiment({
    experimentName: constants.WOF_MIGRATION_EXPERIMENT,
    accountSid: experimentAccountSid,
  });

  if (isLoadingTreatment) {
    return <PageLoader />;
  }

  if (isWiseOwlV2Enabled) {
    return <WiseOwlViewV2 />;
  }

  return <WiseOwlViewV1 />;
};

export default WiseOwlView;
